import {InlineMath} from "react-katex";
function translate(raw){
    return <InlineMath math={raw}/>
}


export const GraphsQuestions = {
    "quizTitle": "Graphs and Equations Quiz",
    "quizSynopsis": "This quiz will test your knowledge of graphs and equations. All content being tested is from the related content area for Graphs and Equations",
    "nrOfQuestions": "4",
    "questions": [
        {
            "question": "What is the horizontal asymptote of the graph of (x^{2}-1)/(x-4)",
            "questionType": "text",
            "questionPic": "", // if you need to display Picture in Question
            "answerSelectionType": "single",
            "answers": [
                "y=1",
                "y=2",
                "y=-1",
                "There are none"
            ],
            "correctAnswer": "4",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "D",
            "point": "20"
        },
        {
            "question": "If f(x) = x + 3 and g (x) = x^{2}, find f ○ g (x)",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "x^{2} + 3",
                "x^{3} + 3",
                "x^{2} + 4",
                "x + 4"
            ],
            "correctAnswer": "1",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "A",
            "point": "20"
        },
        {
            "question": "If f(x) = x + 3 and g (x) = x^{2}, find g ○ g (5)",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "x^{2}+2",
                "x^{2}+3",
                "625",
                "45"
            ],
            "correctAnswer": "3",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "C",
            "point": "10"
        },
        {
            "question": "What is the gradient for the line 4x^2 - 3",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "2",
                "3",
                "x",
                "4",
            ],
            "correctAnswer": "4",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            "point": "30"
        }
    ]
}
export const IntegrationQuiz = {
    "quizTitle": "Integration Quiz",
    "quizSynopsis": "This quiz will test your knowledge of graphs and equations. All content being tested is from the related content area for Graphs and Equations",
    "nrOfQuestions": "4",
    "questions": [
        {
            "question": "What is the horizontal asymptote of the graph of (x^{2}-1)/(x-4)",
            "questionType": "text",
            "questionPic": "", // if you need to display Picture in Question
            "answerSelectionType": "single",
            "answers": [
                "y=1",
                "y=2",
                "y=-1",
                "There are none"
            ],
            "correctAnswer": "4",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "D",
            "point": "20"
        },
        {
            "question": "If f(x) = x + 3 and g (x) = x^{2}, find f ○ g (x)",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "x^{2} + 3",
                "x^{3} + 3",
                "x^{2} + 4",
                "x + 4"
            ],
            "correctAnswer": "1",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "A",
            "point": "20"
        },
        {
            "question": "If f(x) = x + 3 and g (x) = x^{2}, find g ○ g (5)",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "x^{2}+2",
                "x^{2}+3",
                "625",
                "45"
            ],
            "correctAnswer": "3",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "C",
            "point": "10"
        },
        {
            "question": "What is the gradient for the line 4x^2 - 3",
            "questionType": "text",
            "answerSelectionType": "single",
            "answers": [
                "2",
                "3",
                "x",
                "4",
            ],
            "correctAnswer": "4",
            "messageForCorrectAnswer": "Correct answer. Good job.",
            "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
            "explanation": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            "point": "30"
        }
    ]
}